import PropTypes from 'prop-types';

import CustomPrintPlaqueConfigurator from './CustomPrintPlaqueConfigurator';
import withModal from '../../modal/withModal';

const CUSTOM_PRINT_PLAQUE_CONFIGURATOR_MODAL =
  'CUSTOM_PRINT_PLAQUE_CONFIGURATOR_MODAL';

const propTypes = {
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  renderSubmit: PropTypes.func,
};

const CustomPrintPlaqueConfiguratorModal = withModal(
  CustomPrintPlaqueConfigurator,
  {
    name: CUSTOM_PRINT_PLAQUE_CONFIGURATOR_MODAL,
    dismissible: false,
    size: 'sm',
    className: 'custom-print-plaque-configurator-modal',
    type: 'full',
  },
);

CustomPrintPlaqueConfiguratorModal.propTypes = propTypes;

export default CustomPrintPlaqueConfiguratorModal;
